import { Component, OnInit } from "@angular/core";
import { CclRouteTab } from "certain-common-library";
import { SharedService } from "../../../../modules/shared/services/shared.service";

@Component({
    selector: "config-drawer",
    templateUrl: "drawer-section.view.html"
})
export class DefaultDrawerView implements OnInit {
    navLinks: Array<CclRouteTab> = [new CclRouteTab("Basic", "default"), new CclRouteTab("Advanced", "advanced")];
    saveMessage = "drawer-save-connection-message";
    constructor(public sharedService: SharedService) {}

    ngOnInit() {}

    saveFunction() {}

    getDrawer() {
        return this.sharedService.currentDrawer;
    }
}
